import {
  DEFAULT_AUTOMIGRATE_COMMAND_LIST,
  ENTITY_MIGRATIONS_LIST,
} from 'client/const/migrate-consts'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { PageTypeEnum } from 'common/enums/PageTypeEnum'
import ServerPage from 'src/shared/types/server-page-interface'
import migrateBlogLatestPostsCommand from 'tools/commands/migrate/BlogLatestPosts/migrateBlogLatestPostsCommand'
import migrateInlineCommand from 'tools/commands/migrate/Inline/migrateInlineCommand'
import { removeDuplicatedBlogPostLayoutBody } from 'tools/commands/remove-duplicated-blog-post-layout-body'

export const migratePage = (page: ServerPage): ServerPage => {
  const commandList = DEFAULT_AUTOMIGRATE_COMMAND_LIST

  switch (page.type) {
    case PageTypeEnum.BlogHome:
    case PageTypeEnum.BlogPostBody:
    case PageTypeEnum.BlogPostLayout:
    case PageTypeEnum.BlogPostListing:
    case PageTypeEnum.BlogStatic:
    case PageTypeEnum.BlogSearch:
      commandList.push(
        migrateBlogLatestPostsCommand,
        removeDuplicatedBlogPostLayoutBody,
      )
      break
    case PageTypeEnum.Inline:
      commandList.push(migrateInlineCommand)
      break
  }

  return commandList.reduce((page, command) => command(page)[0], page)
}

export const migratePageBlock = (
  structure: ServerPage['content']['entities'],
): ServerPage => {
  const commandList = ENTITY_MIGRATIONS_LIST

  // workaround for migrating blocks utilizing old page migration commands
  const pseudoPage: ServerPage = {
    id: 0,
    user_id: 0,
    created_at: new Date(),
    type: PageTypeEnum.BlogHome,
    locale: PageLocaleEnum.ENGLISH,
    content: {
      entities: structure,
      seo: {},
      globalSettings: {},
    },
  }

  return commandList.reduce((page, command) => command(page)[0], pseudoPage)
}
